import { render } from "./StaticImpressum.vue?vue&type=template&id=76e60007"
import script from "./StaticImpressum.vue?vue&type=script&lang=js"
export * from "./StaticImpressum.vue?vue&type=script&lang=js"

import "./StaticImpressum.vue?vue&type=style&index=0&id=76e60007&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__